<label *ngIf="label">{{ label }}</label>
<ng-content></ng-content>
<span class="error" *ngIf="errorMessage !== null">{{ errorMessage }}</span>
